import "./GirlNames.module.css";
import BrandNavigationHeader from "@/reusable_sections/Header";
import GirlNameDirectory from "./sections/GirlNameDirectory";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function GirlNamesPage() {
  return <div>
      <BrandNavigationHeader />
      <GirlNameDirectory />
      <CompanyDirectory />
    </div>;
}